/*
 * @Description: 总体reducer
 * @Author: wudifu
 * @Date: 2021-01-07 17:51:42
 * @LastEditors: wudifu
 * @LastEditTime: 2021-04-13 13:37:35
 */
import authReducer from "./auth/slice";
import { combineReducers } from "@reduxjs/toolkit";

const rootReducers = combineReducers({
  authReducer,
});
export type RootState = ReturnType<typeof rootReducers>;
export default rootReducers;
